import React from 'react'
import { renderStatementWithKaTeX } from '../../../../../Functions/WriteLaTex'
import './OrderingCards.css'
import OrderingCardsGame from './OrderingCardsGame/OrderingCardsGame'

const OrderingCards = () => {
    const OrderingCardsProblem =['Abdennur was holding a deck of $N$ numbered cards, labeled from $1$ to $N$ in increasing order. Unfortunately, he dropped the deck, and when he picked it up, the cards were in a completely arbitrary order. ',
    'His friend Fedi challenges him to restore the deck to the correct order using only the following two operations, which he may apply in any order and as many times as he wishes:',
'(*) Reverse the order of the deck by placing the top card at the bottom, the second card in the second-to-last position, and so on, until the bottom card is placed on top.',
'(**) If the top card has number $M$, then he rearranges the first $M$ cards so that they are in decreasing order.',
'Show that Abdennur can always restore the deck to the correct order using only these two operations.']
    

  return (
    <div className='Game'>
        <div className='discription'>
        <h1> OFM 2026 Problem 2 : Ordering Cards</h1>
       
         <h2>- Problem Statement - (reformulated)</h2>
         <div className='Statement'>
            {OrderingCardsProblem.map((el)=>(
              <div className='StatementParts'>
                 { renderStatementWithKaTeX(el)}
            
              </div>
              
              ))}
              <a href="https://artofproblemsolving.com/community/c6h3806757p37669709">See Original.</a>
         </div>
         
      </div>
        <OrderingCardsGame/>
    </div>
  )
}

export default OrderingCards